import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'reducers';

/**
 * Memoized selector for the UserDetailsForm component.
 * Consolidates 12 individual useSelector calls into one, reducing re-renders
 * by only recalculating when userStore or assignRolesList change.
 */
export const selectUserDetailsFormContext = createSelector(
  [(state: RootState) => state.userStore, (state: RootState) => state.assignRolesList],
  (userStore, assignRolesList) => ({
    assignedGrandfatherClientNumber: userStore.assignedGrandfatherClientNumber,
    detailedUser: userStore.detailedUser,
    detailedUserLoaded: userStore.detailedUserLoaded,
    detailedUserError: userStore.detailedUserError,
    adminDetailedUser: userStore.adminDetailedUser,
    adminDetailedUserLoaded: userStore.adminDetailedUserLoaded,
    adminDetailedUserError: userStore.adminDetailedUserError,
    loggedInUser: userStore.loggedInUser,
    assignedAccountNumber: userStore.assignedAccountNumber,
    updateUserLoading: userStore.updateUserLoading,
    adminUpdateUserLoading: userStore.adminUpdateUserLoading,
    assignRolesList: assignRolesList.roles,
  })
);
